import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/Motion";
import { CATEGORIES } from "@/data/site";
import { EImg, T } from "@/context/ContentContext";

const SPANS = {
  georgia: "col-span-2 row-span-2",
  group: "col-span-2",
  international: "col-span-1",
  india: "col-span-1",
  honeymoon: "col-span-1",
  weekend: "col-span-1",
  corporate: "col-span-2",
};

export function ExploreBento() {
  return (
    <section className="bg-paper py-24 sm:py-32" data-testid="explore-bento-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead k="home.explore" eyebrow="Explore" title={["Pick a way", "to wander."]} />
        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[170px] sm:auto-rows-[220px] lg:auto-rows-[250px] gap-3 sm:gap-5">
          {CATEGORIES.map((c, i) => (
            <motion.div key={c.key} className={SPANS[c.key]}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}>
              <Link to={c.to} data-testid={`explore-tile-${c.key}`}
                className={`group relative block h-full overflow-hidden ${c.key === "georgia" ? "rounded-[32px]" : "rounded-[24px]"}`}>
                <EImg place="top-3 left-3" k={`home.explore.${c.key}.img`} src={c.image} alt={c.label} loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/20 to-transparent pointer-events-none" />
                <span className="absolute top-3 right-3 sm:top-4 sm:right-4 grid place-items-center h-9 w-9 sm:h-11 sm:w-11 rounded-full bg-paper/90 text-ink transition-[transform,background-color,color] duration-500 group-hover:rotate-45 group-hover:bg-terra group-hover:text-paper">
                  <ArrowUpRight className="h-4 w-4 sm:h-5 sm:w-5" />
                </span>
                <div className="absolute bottom-0 left-0 p-4 sm:p-6 text-cream">
                  {c.key === "georgia" && <T k="home.explore.georgia.badge" as="p" className="eyebrow text-gold mb-3">Signature</T>}
                  <T k={`home.explore.${c.key}.label`} as="p" className={`font-display font-extrabold tracking-tight leading-none ${c.key === "georgia" ? "text-3xl sm:text-5xl" : "text-lg sm:text-2xl"}`}>{c.label}</T>
                  <T k={`home.explore.${c.key}.note`} as="p" className="mt-1.5 text-xs sm:text-sm text-cream/80">{c.note}</T>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
